import { useFormikContext } from 'formik';
import { Field } from 'formik';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import { TextField } from 'components/form/Formik';
import FormikReactSelect from 'components/form/Formik/FormikReactSelect';
import clipboard from 'utils/clipboard';
import { parseAddress } from 'utils/api';
import get from 'lodash/get';
import { FORM_VALIDATION } from 'constants/addressForm';

const DropshipAddressForm = ({ countries }) => {
  const form = useFormikContext();
  const { shippingAddress } = form.values;

  const shippingStates = shippingAddress?.country
    ? countries
        .find((i) => i.country.code === shippingAddress.country)
        .states.map((i) => ({ label: i.name, value: i.short }))
    : [];

  const onPaste = () => {
    clipboard((text) => {
      parseAddress(text).then((resp) => {
        const result = get(resp, '0');
        if (result) {
          const country = countries.find(
            (s) => s.country.name === result.CountryName
          );
          const data = {
            name: result.recipient,
            address1: result.address1,
            address2: result.address2,
            city: result.city,
            state: result.state.length != 2 ? '' : result.state.toUpperCase(),
            zip: result.zip_code,
            country: country ? country.country.code : 'US',
          };
          form.setFieldValue('shippingAddress', data);
        }
      });
    });
  };

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">Drop Ship Address</Typography>
        <Tooltip title="Paste address from Clipboard" placement="top">
          <IconButton
            size="small"
            onClick={onPaste}
            aria-label="paste address from clipboard"
          >
            <LibraryBooksIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Box>
        <TextField
          fullWidth
          label="Name"
          name="shippingAddress.name"
          validate={FORM_VALIDATION.required}
        />
        <TextField
          fullWidth
          label="Business Name (optional)"
          name="shippingAddress.businessName"
        />
        <TextField
          fullWidth
          label="Address"
          name="shippingAddress.address1"
          validate={FORM_VALIDATION.required}
        />
        <TextField
          fullWidth
          label="Address line 2"
          name="shippingAddress.address2"
        />
        <TextField
          fullWidth
          label="City"
          name="shippingAddress.city"
          validate={FORM_VALIDATION.required}
        />
        {countries.length > 1 ? (
          <Field
            fullWidth
            transformValue
            label="Country"
            name="shippingAddress.country"
            component={FormikReactSelect}
            options={countries.map((i) => ({
              label: i.country.name,
              value: i.country.code,
            }))}
            validate={FORM_VALIDATION.required}
          />
        ) : null}
        <Field
          fullWidth
          transformValue
          component={FormikReactSelect}
          label="State / Province"
          name="shippingAddress.state"
          options={shippingStates}
          validate={FORM_VALIDATION.required}
        />
        <TextField
          fullWidth
          label="Zip"
          name="shippingAddress.zip"
          validate={FORM_VALIDATION.required}
        />
      </Box>
    </>
  );
};

export default DropshipAddressForm;
